<div class="member-home-container">
  <div class="header bold" data-qa="member-page-header">MEMBER</div>
  <div class="dashboard-container">
    <app-header-statistics [headerStatistics]="memberStatisticsForHeader"></app-header-statistics>
  </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12" *ngIf="labelModelMemberComplianceCode !== undefined">
        <!-- MemberCompliance Bar Chart -->
        <app-kpi [cModel]="chartModelMemberComplianceCode" [cDataLabels]="labelModelMemberComplianceCode" [cDataModel]="arrMemberComplianceCode" [cOptions]="dataOptionsMemberComplianceCode"></app-kpi>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12" *ngIf="labelModelExemptedMembers !== undefined">
        <!-- Exempted Members Bar Chart -->
        <app-kpi [cModel]="chartModelExemptedMembers" [cDataLabels]="labelModelExemptedMembers" [cDataModel]="arrExemptedMembers" [cOptions]="dataOptionsExemptedMembers"></app-kpi>
      </div>
    </div>

  </div>
